import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { LogoutResponse } from '../../../login/login.viewmodel';
import { CACHE_KEYS } from '../../constants/cache-keys';
import { CacheService } from '../cache.service';
import { LoginService } from '../../../login/login.service';
import { finalize } from 'rxjs';
import { AuthService } from './auth.service';
import { LPMI_ROUTES } from '../../constants/routes';
import { isLPMIHost } from '../../util/utils';
import { environment } from '../../../../environments/environment';


@Injectable({ providedIn: 'root' })
export class loginAuthGuard implements CanActivate {
  constructor(private cacheService: CacheService, private oAuthService: OAuthService, private authService: AuthService,
    private loginService: LoginService) { }

  canActivate(): boolean {
    const host = (window?.location?.hostname || '').toLowerCase();
    const isLpmi = isLPMIHost(host, environment.LPMI_URL);
    const hasValidAccessToken = this.oAuthService.hasValidAccessToken();
    if (isLpmi && !hasValidAccessToken) {
      this.authService.login('pf', null);
      return false; // cancel Angular route activation
    }
    if (hasValidAccessToken) {
      // Clear cache synchronously FIRST to prevent stale data from being used during component loading
      this.cacheService.clearCache();
      
      // Then call async logout cleanup (fire and forget is OK since cache is already cleared)
      this.loginService.logout()
        .pipe(
          finalize(() => {
            this.cacheService.removeFromCache(CACHE_KEYS.LOGIN.LANGUAGE);
              this.loginService.idpLogout();
          })
        )
        .subscribe({
          next: (response: LogoutResponse) => {
            if (response?.success) {
              console.log('Cache evicted');
            }
          }, error: (err: any) => {
            console.log('Already logged out');
          }
        });
      return true; // Allow access to login after clearing session.
    }
    return true; // Allow access to login
  }
}

